import { useNavigate, useLocation } from 'react-router'
import { useTranslation } from 'react-i18next'

export const NAV_ITEMS = [
    { path: '/', labelKey: 'navHome', icon: 'bi-house-door', iconActive: 'bi-house-door-fill' },
    { path: '/expenses', labelKey: 'navExpenses', icon: 'bi-receipt', iconActive: 'bi-receipt-cutoff' },
    // Shopping is nested under tasks — keep this tab lit on /shopping too
    { path: '/tasks', labelKey: 'navTasks', icon: 'bi-check2-square', iconActive: 'bi-check2-square', match: ['/tasks', '/shopping'] },
    { path: '/group', labelKey: 'navGroup', icon: 'bi-people', iconActive: 'bi-people-fill' },
    { path: '/settings', labelKey: 'navSettings', icon: 'bi-gear', iconActive: 'bi-gear-fill' },
];

function isActive(item, pathname) {
    return (item.match || [item.path]).includes(pathname);
}

export default function Navbar() {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { t } = useTranslation('common');

    return (
        <nav className="bottom-nav" data-tour="main-nav" aria-label={t('mainNav')}>
            {NAV_ITEMS.map(item => {
                const active = isActive(item, pathname);
                return (
                    <button
                        key={item.path}
                        type="button"
                        className={`nav-btn ${active ? 'active' : ''}`}
                        onClick={() => navigate(item.path)}
                        aria-current={active ? 'page' : undefined}
                    >
                        <i className={`bi ${active ? item.iconActive : item.icon}`} aria-hidden="true" />
                        <span>{t(item.labelKey)}</span>
                    </button>
                );
            })}
        </nav>
    )
}
